import { render, staticRenderFns } from "./MailResend.vue?vue&type=template&id=0dffa545"
import script from "./MailResend.vue?vue&type=script&lang=js"
export * from "./MailResend.vue?vue&type=script&lang=js"
import style0 from "./MailResend.vue?vue&type=style&index=0&id=0dffa545&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports